/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_S2Inputs */

const en_vc_status_s2 = /** @type {(inputs: Vc_Status_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`feature depth compared with Illustrator`)
};

const zh_vc_status_s2 = /** @type {(inputs: Vc_Status_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能深度（与 Illustrator 相比）`)
};

/**
* | output |
* | --- |
* | "feature depth compared with Illustrator" |
*
* @param {Vc_Status_S2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_s2 = /** @type {((inputs?: Vc_Status_S2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_S2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_s2(inputs)
	return zh_vc_status_s2(inputs)
});
export { vc_status_s2 as "vc.status.s2" }